import { render, staticRenderFns } from "./new-template-item.vue?vue&type=template&id=f294fdfa"
import script from "./new-template-item.vue?vue&type=script&lang=js"
export * from "./new-template-item.vue?vue&type=script&lang=js"
import style0 from "./new-template-item.vue?vue&type=style&index=0&id=f294fdfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports